
export default function handleDate( e ) {
    let targetParent = e.target.parentNode.className;
    let startDate = 'start-date-field';

    let month = ( startDate === targetParent ) ? 'mce-MMERGE6-month' : 'mce-MMERGE7-month';
    let day = ( startDate === targetParent ) ? 'mce-MMERGE6-day' : 'mce-MMERGE7-day';
    let year = ( startDate === targetParent ) ? 'mce-MMERGE6-year' : 'mce-MMERGE7-year';

    const getId = ( id ) => document.getElementById( id );
    const isNotNumber = isNaN( getId( month ).value ) || isNaN( getId( day ).value ) || isNaN( getId( year ).value );
    const handleInputs = ( id ) => ( isNotNumber ) ? getId( id ).value = '' : getId( id ).onkeydown = ( e ) => handleChange( id, e );

    handleInputs( month );
    handleInputs( day );
    handleInputs( year );

    function handleChange( id, e ) {
        getId( id ).value.length === 0 && e.key === "Backspace" && getId( id === day ? month : id === year && day) && getId( id === day ? month : id === year ? day : "").focus()

        // getId( id ).value.length === getId( id ).maxLength && e.key !== "Backspace" && getId( id === month ? day : id === day && year) && getId( id === month ? day : id === day ? year : "").focus()
    }
};
